// Modernization paths
const PATH5 = "5. Standalone DataStage (non-CP4D)";
const PATH4 = "4. CP4D DataStage - Classic Runtime (Grid conversion required)";
const PATH3 = "3. CP4D DataStage - Classic Runtime";
const PATH2 = "2. CP4D DataStage - New PX Runtime (Server conversion required)";
const PATH1 = "1. CP4D DataStage - New PX Runtime";

export {
    PATH1,
    PATH2,
    PATH3,
    PATH4,
    PATH5
};